import { ApolloLink, Observable, Operation, FetchResult } from "@apollo/client"
import { Consumer } from "@rails/actioncable"
import { print } from "graphql"

interface ActionCableLinkOptions {
  cable: Consumer
  channelName: string
}

interface GraphQLCableMessage {
  result?: FetchResult
  more?: boolean
}

export class ActionCableLink extends ApolloLink {
  private cable: Consumer
  private channelName: string

  constructor({ cable, channelName }: ActionCableLinkOptions) {
    super()
    this.cable = cable
    this.channelName = channelName
  }

  public request(operation: Operation): Observable<FetchResult> {
    return new Observable<FetchResult>(observer => {
      const sub = this.cable.subscriptions.create(
        { channel: this.channelName },
        {
          connected: () => {
            sub.perform("execute", {
              query: print(operation.query),
              variables: operation.variables,
              operationName: operation.operationName,
            })
          },
          received: (payload: GraphQLCableMessage) => {
            if (payload.result) {
              observer.next(payload.result)
            }
            if (payload.more === false) {
              observer.complete()
            }
          },
          disconnected: () => {
            observer.error(new Error("ActionCable disconnected"))
          },
        },
      )

      return () => {
        sub.unsubscribe()
      }
    })
  }
}
